export default {"src":"/_next/static/media/tech-crunch.abf61f01.svg","height":16,"width":33,"blurWidth":0,"blurHeight":0};